<template>
  <div class="course-goods-list">
    <div class="goods-wrap">
      <div class="title-bar">
        <a-row type="flex" justify="space-between">
          <a-col :span="4">
            <slot name="title"> </slot>
          </a-col>
        </a-row>
      </div>
      <div class="goods-list">
        <a-empty
          :description="'暂无数据'"
          v-if="!spinning && goodsList.length == 0"
        />
        <a-spin :spinning="spinning">
          <a-row type="flex" justify="start" v-if="goodsList.length > 0">
            <a-col :span="6" v-for="(item, index) in goodsList" :key="index">
              <PhotoCard :img="item.activityCover_url">
                <div slot="content" @click="toGoodsDetail(item.id)">
                  <h3 class="title">{{ item.activityName }}</h3>
                  <span class="post">{{ item.activityDesc }}</span>
                </div>
                <div slot="icon">
                  <li>
                    <a-icon type="qrcode"></a-icon>
                  </li>
                </div>
              </PhotoCard>
            </a-col>
          </a-row>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivityList, getBuyLink } from "@/api/goods";
import { getDict } from "@/api/sys";
import PhotoCard from "@/components/common/PhotoCard";
export default {
  name: "CourseGoodsList",
  components: {
    PhotoCard: PhotoCard,
  },
  props: {
    type: {
      //活动类型：0入门点播 1进阶点播
      type: Number,
      default: null,
    },
    status: {
      //活动状态：1正常 2已推荐
      type: Number,
      default: null,
    },
    limit: {
      //数量
      type: Number,
      default: 99,
    },
  },
  data() {
    return {
      courseTypes: [],
      goodsList: [],
      spinning: true,
    };
  },
  created() {
    // this.getCourseTypes();
    this.getActivityList();
  },
  methods: {
    getCourseTypes() {
      getDict("course_type").then((res) => {
        if (res.success) {
          this.workTags = res.result;
        }
      });
    },
    getActivityList() {
      getActivityList(this.type, null, null, this.status, this.limit).then(
        (res) => {
          this.goodsList = res.result;
          this.spinning = false;
        }
      );
    },
    toGoodsDetail(actId) {
      console.log(actId);
      this.$router.push({
        path: `/course/goodsDetail?actId=${actId}`,
      });
    },
  },
};
</script>

<style lang="less">
.course-goods-list {
  min-height: 200px;
  .title-bar {
    text-align: left;
    margin: 50px 10px;
    i {
      font-size: 25px;
    }
    .title {
      font-size: 20px;
      font-weight: 700;
      color: white;
      margin-left: 10px;
      display: inline;
      text-shadow: 0px 0px 2px black;
    }
  }
  .goods-list {
    .photo-card {
      margin: 20px 30px;
      cursor: pointer;
      box-shadow: 0px 9px 9px 0px #00000038;
    }
  }
}
</style>